import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../../components/Loader";
import styles from "./leases.module.css";
import React from "react";
import { Helmet } from "react-helmet";
import { useState } from "react";
import { Typography } from "@mui/material";
import { Home } from "react-feather";
import Footer from "../../components/Footer";
import LeaseGridView from "./gridview/LeaseGridView";
import LeaseListView from "./listview/LeaseListView";
import { useEffect } from "react";
import axios from "axios";

const Leases = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [isGridView, setIsGridView] = useState(false);
    const [hasGridRendered, setHasGridRendered] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [allData, setAllData] = useState([]);
    const [filterData, setFilterData] = useState({ searchKey: "", property: "", apartment: "", status: "" });

    useEffect(() => {
        async function getLeases() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/leases", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setAllData(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }
        getLeases();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        if (localStorage.getItem("leaseStatusyFilterData")) {
            setIsGridView(true);
            setHasGridRendered(true);
        }
    }, []);

    const handleView = (view) => {
        if (view === "grid") {
            setIsGridView(true);
            setHasGridRendered(true);
        } else {
            setIsGridView(false);
        }
    }

    return (<React.Fragment>
        <Helmet title="Leases" />

        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Leases</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Payment</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Leases</li>
                </ol>
            </nav>
        </div>

        {/* List View */}
        <div style={{ display: isGridView ? "none" : "block" }}>
            <LeaseListView contentLoading={contentLoading} allData={allData} isGridView={isGridView} handleView={handleView.bind(this)} filterData={filterData} setFilterData={setFilterData.bind(this)} />
        </div>

        {/* Grid View */}
        {hasGridRendered && (<div style={{ display: isGridView ? "block" : "none" }}>
            <LeaseGridView contentLoading={contentLoading} allData={allData} isGridView={isGridView} handleView={handleView.bind(this)} filterData={filterData} setFilterData={setFilterData.bind(this)} />
        </div>)}


        <Footer />
    </React.Fragment>)
}

export default withAuthenticationRequired(Leases, {
    onRedirecting: () => <Loader />,
});